import { useMemo } from 'react';
import { number } from '../../../../Util/number';
import { useServicesChartsDataContext } from '../../../hooks/useServicesChartsDataContext';

const useServicesPerYearDonutChart = () => {
    const { chartData, subtitles, filters } = useServicesChartsDataContext();

    const series = useMemo(
        () =>
            subtitles.map((item) => {
                const data =
                    chartData.counterYear
                        .filter(
                            (counter) => (counter.description ?? '-') === item
                        )
                        .filter(
                            (item) => item.ano_competencia === filters.ano.value
                        )
                        ?.reduce(
                            (acc, curr) => acc + Number(curr.services),
                            0
                        ) || 0;

                return data;
            }),
        [chartData, subtitles, filters.ano.value]
    );

    return {
        series,
        subtitles
    };
};

export default useServicesPerYearDonutChart;
